import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap'
import BuyModal from '../../element/buy-modal'
import PriceArea from '../../charts/price-area'

import {loanActions} from '../../../redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { userSelect, loanSelect, homeScreenStatSelect, allRemoteSettingsSelect, allDepositSelect } from '../../../redux/selectors/index';
import Helper1, {notify, subStr, addUrlToPath, moneyStatus, usefulColors, money} from '../../../utility/Helper1';
import LoadingIcon from "../../../utility/customComponents/loader/LoadingIcon";
import copy from 'copy-to-clipboard';
import { AiOutlineWallet, AiFillDelete, AiOutlineCopy, AiOutlineCloudUpload } from "react-icons/ai";
import Countdown from 'react-countdown';
import WrapUpDashboard from '../../layout/WrapUpDashboard'
import NoData from "../../../utility/customComponents/NoData";
import LoanSubMenu from "./Loan-sub-menu";


const OnlineLoan = () => {
    const [show, setShow] = useState(false);


    const dispatch = useDispatch();
    const site_settings                                 = useSelector(allRemoteSettingsSelect);
    const userData = useSelector(userSelect);    
    const finance = useSelector(homeScreenStatSelect);
    
    const [loading, setloading] = useState(false)

    useEffect(() => {

        setloading(true)

        dispatch(loanActions.onGET("loan/all", response => {
            setloading(false)
        }),
        )
    }, [])

    const getUserLoans = useSelector(loanSelect);

console.log('getUserLoans', getUserLoans)

    const theTenures = [
                {
                    title: 'SHORT TERM',
                    subTitle: 'Market Position'
                },
                {
                    title: 'LONG TERM',
                    subTitle: 'Asset Holdings'
                }
            ]

    return (
        <WrapUpDashboard pageTitle={"Available trades"}>

            <div className="card-header">
                <LoanSubMenu pageTitle={'All Loans'}/>
            </div>

            <div className="row">



                <div className="col-xxl-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Available Loans</h4>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-striped responsive-table">
                                    <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>Method</th>
                                            <th>Txn_id</th>
                                            <th>Time</th>
                                            <th>Capital</th>
                                            <th>Down payment</th>
                                            <th>Status</th>
                                            <th>Repayment date</th>
                                            <th>Repayment amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        


                                        {getUserLoans?.map((item, index) => {

                                            let image = finance?.filter((filitem, index) => filitem.type == item.currencyId)

                                        return <tr>
                                                    <td><span className="info-arrow"><i className="icofont-arrow-left"></i>
                                                        Loan</span>
                                                    </td>
                                                    <td className="coin-name">
                                                        <img style={{width: 30, height: 30}} src={image?.[0]?.image} alt="img" />
                                                    </td>
                                                    <td>
                                                        <span className="text-muted">
                                                            {item.txn_id}
                                                        </span>
                                                    </td>

                                                    <td>
                                                        {item?.applicationTime}
                                                    </td>

                                                    <td className="text-danger">
                                                        {money(item.amountRequested, item.currencyId)}
                                                    </td>


                                                    <td className="text-danger">
                                                        {money(item.partAmountPayed, item.currencyId)}
                                                    </td>


                                                    <td>
                                                        <span className={`text-${usefulColors(item?.status)}`}>{moneyStatus()[item?.status]}</span>
                                                    </td>


                                                    <td className="text-danger">
                                                        {item.repayment_date}
                                                    </td>

                                                    <td className="text-danger">
                                                        {money(item.repayment_amount, item.currencyId)}
                                                    </td>

                                        </tr>})}
                                        

                                        {(getUserLoans?.length ?? 0) == 0 && loading && <tr>
                                            <td colSpan={5} className="text-center">
                                                <LoadingIcon color={"green"} active={loading} />
                                            </td>
                                        </tr>}

                                    </tbody>
                                </table>

                                {(getUserLoans?.length ?? 0) == 0 && !loading && <NoData subTitle="loan" />}

                            </div>
                        </div>
                    </div>
                </div>


            </div>
        



        </WrapUpDashboard>
    );
};

export default OnlineLoan;